import { RoleType } from '@entities/profile/model/types'
import { sessionApi } from '@shared/api/server'

import { ProfileModel } from './profile.model'

export interface IProfileRepository {
  update(): Promise<ProfileModel>
  set(
    userName: string,
    userRole: string,
    untilDate: string | Date,
    subDays: number | null
  ): ProfileModel
}

export class ProfileRepository implements IProfileRepository {
  async update(): Promise<ProfileModel> {
    const response = await sessionApi.getProfileInfoCall()
    return new ProfileModel(
      response.userFullName,
      response.userRole,
      response?.paidUpUntil ? new Date(response.paidUpUntil) : new Date(),
      response?.subDaysRemain ?? null
    )
  }
  set(
    userName: string,
    userRole: string,
    untilDate: string | Date,
    subDays: number | null
  ): ProfileModel {
    return new ProfileModel(
      userName,
      userRole as RoleType,
      untilDate ? new Date(untilDate) : new Date(),
      subDays ?? null
    )
  }
}
